import React from 'react';
import classNames from 'classnames';

import Img from '../../../components/Img';

export default function Idea({ selected, wasSelected, onClick, idea, title }) {
  const imageTitle = title ? <div>{title}</div> : undefined;

  return (
    <button
      className={classNames('w-full h-full', 'ideation-selector-ideas-idea', {
        'ideation-selector-ideas-idea--selected': selected,
        'ideation-selector-ideas-idea--selected-for-other-questions':
          wasSelected,
      })}
      onClick={selected || wasSelected ? undefined : onClick}
    >
      {imageTitle}
      <Img src={idea.url} aspectRatio={1} />
    </button>
  );
}
